import { colors } from '@/constants/colors'
import * as React from 'react'
import Svg, { Circle, Path } from 'react-native-svg'

const SuccessCheckmark = ({ height = 22, width = 22 }) => (
	<Svg width={height} height={width} viewBox="0 0 22 22" fill="none">
		<Circle cx={11} cy={11} r={11} fill={colors.palette_10} />
		<Path d="M5.61377 11.0059L9 15.5" stroke="#76CABB" strokeWidth={2} />
		<Path d="M7.77148 15.5057L17.4999 6.2679" stroke="#76CABB" strokeWidth={2} />
	</Svg>
)

export default SuccessCheckmark
